import { useEffect } from 'react';
export function useWindowResizeEvent(onScreenResize, callOnMount) {
    if (callOnMount === void 0) { callOnMount = false; }
    useEffect(function () {
        var handleResize = function () {
            onScreenResize(window.innerWidth, window.innerHeight);
        };
        if (callOnMount) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [onScreenResize, callOnMount]);
}
//# sourceMappingURL=useWindowResizeEvent.js.map